import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AgmCoreModule } from '@agm/core';

import { environment } from '@app/environments/environment';
import { AWSService } from '@app/app/shared/services/aws.service';
import { InterceptorService } from '@app/app/shared/services/interceptor.service';
import { SlidedownComponent } from '@app/app/shared/components/slidedown/slidedown.component';
import { TabComponent } from '@app/app/shared/components/tabs/tab/tab.component';
import { TabsComponent } from '@app/app/shared/components/tabs/tabs.component';
import { CustomTabComponent } from '@app/app/shared/components/custom-tabs/custom-tab/custom-tab.component';
import { CustomSubTabComponent } from '@app/app/shared/components/custom-tabs/custom-subtab/custom-tab.component';
import { CustomTabsComponent } from '@app/app/shared/components/custom-tabs/custom-tabs.component';
import { PaginationComponent } from '@app/app/shared/components/pagination/pagination.component';
import { GooglePlaceDirective } from '@app/app/shared/directives/google.places.directive';
import { WeatherService } from '@app/app/shared/services/weather.service';
import { ParksService } from '@app/app/shared/services/parks.service';
import { ParksResolver } from '@app/app/shared/resolvers/parks.resolver';
import { MessageService } from '@app/app/shared/services/message.service';
import {ClockService} from '@app/app/shared/services/clock.service';
import {CognitoService} from '@app/app/shared/services/cognito.service';
import {RefreshTokenService} from '@app/app/shared/services/refresh-token.service';
import {RefreshTokenInterceptorService} from '@app/app/shared/services/refresh-token-interceptor.service';

import { ColorPickerModule } from 'ngx-color-picker';
import {MatSnackBarModule} from '@angular/material/snack-bar';

@NgModule({
  declarations: [
    SlidedownComponent,
    TabComponent,
    TabsComponent,
    PaginationComponent,
    GooglePlaceDirective,
    CustomTabComponent,
    CustomSubTabComponent,
    CustomTabsComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    AgmCoreModule.forRoot({
      apiKey: environment.google.maps.key,
      libraries: ['places']
    }),
    ColorPickerModule,
    MatSnackBarModule
  ],
  exports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    AgmCoreModule,
    SlidedownComponent,
    TabComponent,
    TabsComponent,
    PaginationComponent,
    GooglePlaceDirective,
    CustomTabComponent,
    CustomSubTabComponent,
    CustomTabsComponent,
    ColorPickerModule,
    MatSnackBarModule
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        WeatherService,
        ParksService,
        ParksResolver,
        AWSService,
        CognitoService,
        MessageService,
        ClockService,
        RefreshTokenService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: RefreshTokenInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: InterceptorService,
          multi: true,
        }
      ],
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts